module.exports = __webpack_public_path__ + "img/2-1.af2c9265.jpg";